function colorOption(name, hex) {
  return { name, value: hex, color: hex }
}

function extraShades(shades, skipHex) {
  const skip = skipHex.toLowerCase()
  return shades
    .filter(shade => shade.hex.toLowerCase() !== skip)
    .map(shade => colorOption(shade.name, shade.hex))
}

const PRIMARY_SHADES = [
  { name: 'Jordy Blue', hex: '#93AFFD' },
  { name: 'Cornflower Blue', hex: '#6088FA' },
  { name: 'Ultramarine', hex: '#3B6CF6' },
  { name: 'Royal Blue', hex: '#2559EB' },
  { name: 'Cerulean Blue', hex: '#1D4ED8' },
  { name: 'Cobalt Blue', hex: '#1E44AF' },
  { name: 'Sapphire', hex: '#1E3A8A' },
  { name: 'Midnight Blue', hex: '#172754' },
]

const DANGER_SHADES = [
  { name: 'Pink', hex: '#FCCCCC' },
  { name: 'Light Coral', hex: '#F9A8A9' },
  { name: 'Salmon', hex: '#F37677' },
  { name: 'Roman', hex: '#EA5455' },
  { name: 'Crimson', hex: '#D52D2E' },
  { name: 'Firebrick', hex: '#B32223' },
  { name: 'Cardinal', hex: '#942021' },
  { name: 'Maroon', hex: '#7B2122' },
  { name: 'Dark Chocolate', hex: '#430C0C' },
]

const SUCCESS_SHADES = [
  { name: 'Light Green', hex: '#8FE6AE' },
  { name: 'Emerald', hex: '#56D283' },
  { name: 'Fern Green', hex: '#30B762' },
  { name: 'Chateau Green', hex: '#26AA57' },
  { name: 'Forest Green', hex: '#1E773F' },
  { name: 'Hunter Green', hex: '#1D5E36' },
  { name: 'Pine Green', hex: '#194E2E' },
  { name: 'Dark Green', hex: '#082B17' },
]

const WARNING_SHADES = [
  { name: 'Peach', hex: '#FFDAA8' },
  { name: 'Light Orange', hex: '#FFC071' },
  { name: 'Neon Carrot', hex: '#FF9F43' },
  { name: 'Dark Orange', hex: '#FE7B11' },
  { name: 'Tangerine', hex: '#EF6007' },
  { name: 'Burnt Orange', hex: '#C64608' },
  { name: 'Rust', hex: '#9D390F' },
  { name: 'Sienna', hex: '#7E3010' },
  { name: 'Brown', hex: '#441506' },
]

const SECONDARY_SHADES = [
  { name: 'Cadet Gray', hex: '#AFBACA' },
  { name: 'Slate Gray', hex: '#8495AC' },
  { name: 'Steel Blue', hex: '#647793' },
  { name: "Payne's Gray", hex: '#506079' },
  { name: 'Charcoal', hex: '#414E63' },
  { name: 'Oxford Blue', hex: '#374151' },
  { name: 'Gunmetal', hex: '#333B47' },
  { name: 'Dark Slate', hex: '#22272F' },
]

const STATUS_COLOR_OPTIONS = [
  colorOption('Primary', '#1D4ED8'),
  ...extraShades(PRIMARY_SHADES, '#1D4ED8'),
  colorOption('Info', '#00cfe8'),
  colorOption('Danger', '#ea5455'),
  ...extraShades(DANGER_SHADES, '#ea5455'),
  colorOption('Success', '#26aa57'),
  ...extraShades(SUCCESS_SHADES, '#26aa57'),
  colorOption('Warning', '#ff9f43'),
  ...extraShades(WARNING_SHADES, '#ff9f43'),
  colorOption('Secondary', '#374151'),
  ...extraShades(SECONDARY_SHADES, '#374151'),
]

export default STATUS_COLOR_OPTIONS
